// removed by extract-text-webpack-plugin
module.exports = {"container":"_23v6YqzaOWiow6hn4sBdI3","content":"_1UWWcvJD94FT7TwveyhJtG","logo":"_1QkDqSwV-up3kUyQ3hvn_X","subLogo":"EXZ13_Nfk6PDgVGrdtpo1","logoUp":"_3dAun9Moi5FsI8iP1cayyQ","middle":"cc4AHduTpJg4L9z2_pJ8b","user":"_2nAw97bG_I87yhNGxcCkp3","borderBottom":"_3oSuqwQWFmpZRuri_PWfj2","borderBottomFixed":"_9S7Lwrjy9NO226lagp1sY"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Layout/Navbar/styles.css
// module id = 1297
// module chunks = 0